import { computed, inject } from 'vue';
import {
  getAddressFromAsset,
  getAssetsFromElement,
} from '@sonarwatch/portfolio-core';
import usePortfolio from '@/views/Portfolio-v2/usePortfolio';

export default function useJupData() {
  const { portfolioInfo } = inject('portfolioData') as ReturnType<
    typeof usePortfolio
  >;

  const holdingJup = computed(() => {
    let total = 0;
    portfolioInfo.assetWalletTokens.value.forEach((item) => {
      const address = getAddressFromAsset(item);
      const value = item.data.amount as number;
      if (address === 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN') {
        total += value;
      }
    });
    return total;
  });

  const staked = computed(() => {
    let total = 0;
    portfolioInfo.elementsByPlatformId.value.forEach((element) => {
      element.elements.forEach((e: any) => {
        getAssetsFromElement(e).forEach((elem: any) => {
          if (
            element.platformId === 'jupiter-governance' &&
            elem.data.address === 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN'
          ) {
            total += elem.data.amount;
          }
        });
      });
    });
    return total;
  });

  const total = computed(() => {
    return holdingJup.value + staked.value;
  });

  const stakedPourcent = computed(() => {
    if (total.value === 0) return 0;
    return (staked.value / total.value) * 100;
  });

  const isFullStaked = computed(() => {
    return staked.value === total.value;
  });

  return {
    total,
    stakedPourcent,
    isFullStaked,
  };
}
